(function (factory) {
	typeof define === 'function' && define.amd ? define('@angular/material', factory) :
	factory();
}((function () { 'use strict';

	/**
	 * @license
	 * Copyright Google LLC All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	// primary entry-point which is empty as of version 9. All components should
	// be imported through their individual entry-points. This file is needed to
	// satisfy the "ng_package" bazel rule which also requires a primary entry-point.

})));
//# sourceMappingURL=material.umd.js.map
